import BashkirStateMedicalUniversityPDF from "../collegesData/BASHKIRSTATEMEDICALUNIVERSITYRUSSIAUPDATED.pdf";
import ImmanuelKantBalticFederalUniversityPDF from "../collegesData/ImmanuelKantBalticFederalUniversityfee.pdf";
import KabardinoBalkarianMedicalUniversityPDF from "../collegesData/KabardinoBalkarianMedicalUniversityUpdatedFee.pdf";
import KazanFederalUniversityPDF from "../collegesData/KAZANFEDERALUNIVERSITYRUSSIAFEE.pdf";
import KazanStateMedicalUniversityPDF from "../collegesData/KAZANSTATEMEDICALUNIVERSITYRUSSIAFEE.pdf";
import KemerovoStateUniversityPDF from "../collegesData/KemerovoStateUniversityUpdatedFee.pdf";
import KurskStateMedicalUniversityPDF from "../collegesData/KURSKSTATEMEDUNIfee.pdf";
import NorthernStateMedicalUniversityPDF from "../collegesData/NORTHERNSTATEMEDICALUNIVERSITYfee.pdf";
import OrelStateMedicalUniversityPDF from "../collegesData/ORELSTATEMEDUNIVERSITYRUSSIAUPDATEDFEE.pdf";
import RostovStateMedicalUniversityPDF from "../collegesData/RostovStateMedicalUniversityRussiafee.pdf";
import SouthUralStateMedicalUniversityPDF from "../collegesData/SouthUralStateMedicalUniversityUpdatedFee.pdf";
import TverStateMedicalUniversityPDF from "../collegesData/TVERSTATEMEDUNIVERSITYRUSSIAFEE.pdf";
import YaroslavlStateMedicalUniversityPDF from "../collegesData/YAROSLAVLSTATEMEDUNIVERSITYRUSSIAFEE.pdf";
import YaroslavTheWiseNovgorodUniversityPDF from "../collegesData/YaroslavThewiseNovgorodStateUniversityRussiaFee.pdf";

export const russiaCollege = [
 {
  id: "1",
  universityDescription: `Bashkir State Medical University (BSMU), located in Ufa, Russia, is one of the oldest and most prestigious medical universities in the country. Established in 1932, BSMU is ranked among the top 10 medical universities in Russia for MBBS education.<br/><br/>

<strong>Highlights</strong><br/>
• The university hosts a large clinic with over 24,000 annual patient visits, offering extensive clinical exposure to students.<br/>
• English-medium MBBS program available.<br/>
• Home to over 10,000 students from 40 different countries.<br/>
• Recognized as a large scientific research center in Russia.<br/>
• The scientific library contains approximately 527,000 items, making it one of Russia’s best medical libraries.<br/>
• Equipped with state-of-the-art laboratories and research infrastructure.<br/>
• Affordable tuition fee and low living costs.<br/>
• Offers five fully furnished, air-conditioned hostels accommodating about 2,000 students. Hostel rooms are flat-type with kitchen, bathroom, and toilet, shared by 2–3 students.<br/><br/>

<strong>Fee Structure (2023-24)</strong><br/>
• 1st Year: 500,000 Rubles (including tuition, hostel, and other miscellaneous expenses)<br/>
• 2nd–6th Year: 317,244 Rubles/year (Tuition + Hostel)<br/>
• Total Fee (6 years): 20,86,220 Rubles (Approx. ₹20,86,220)<br/><br/>

<strong>Other Expenses</strong><br/>
• Medical Insurance, Check-ups, Visa Renewal: ~10,000–12,000 Rubles/year<br/>
• Vaccination: up to 12,500 Rubles (one-time)<br/>
• Food: ~80–100 USD/month (~₹90,000/year)<br/><br/>

<strong>Admission Details</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• Total Initial Charges: ₹120,000<br/>`,

  collegename: "Bashkir State Medical University",
  established: "1932-01-01",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by Russian Ministry of Health",
  address: "Ufa, Republic of Bashkortostan, Russia",
  state: "Republic of Bashkortostan",
  city: "Ufa",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: BashkirStateMedicalUniversityPDF, // replace with actual PDF variable if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "6 years",
    tuitionFee: "20,86,220 Rubles", // As per 6-year total provided
   },
  ],
  cutoffdata: [], // No official cutoff data provided
  website: "https://www.bashgmu.ru/en/", // Official English website
  mail: "admissionpossibility@gmail.com", // Based on contact provided
  image1:
   "https://www.ruseducation.in/wp-content/uploads/2022/01/Bashkir-State-Medical-University.webp",
  image2:
   "https://bashgmu.ru/upload/medialibrary/2a8/2a851829e3888e36de279ad16b955ccb.jpg",
 },
 {
  id: "3",
  universityDescription: `Immanuel Kant Baltic Federal University, located in Kaliningrad, Russia, is a prestigious institution offering high-quality medical education with a modern infrastructure. The MBBS program is conducted in English medium and spans over six years.<br/><br/>

<strong>Highlights</strong><br/>
• Recognized by major international medical councils and listed in global directories.<br/>
• Affordable tuition and living costs make it a popular choice among international students.<br/>
• Well-equipped hostels and medical insurance included in the first-year package.<br/>
• 1st Year fee includes Tuition, Hostel, Insurance, Registration, Visa Extension, Documentation, Notarization, Medical, Fingerprinting, and Administrative charges.<br/><br/>

<strong>Fee Structure (2023-24)</strong><br/>
• 1st Year: 7000 USD (Approx. ₹5,60,000)<br/>
• 2nd–6th Year: 5000 USD/year (Approx. ₹4,00,000/year)<br/>
• Total Fee (6 years): 32,000 USD (Approx. ₹25,60,000)<br/><br/>

<strong>Other Expenses</strong><br/>
• Food: ~100 USD/month (~₹85,000/year)<br/>
• Fees are subject to change based on exchange rates (₹80/USD)<br/><br/>

<strong>Admission Details</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• Total Initial Charges: ₹120,000<br/><br/>

For more information, contact:<br/>
Admission Possibility<br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a>, <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Immanuel Kant Baltic Federal University",
  established: null, // Not mentioned in the provided paragraph
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by Russian Ministry of Health",
  address: "Kaliningrad, Russia",
  state: "Kaliningrad Oblast",
  city: "Kaliningrad",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: ImmanuelKantBalticFederalUniversityPDF, // replace with actual PDF variable if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null, // Research needed for specific seat data
    courseDuration: "6 years",
    tuitionFee: "32,000 USD (Approx. ₹25,60,000)", // Full program fee
   },
  ],
  cutoffdata: [], // No official cutoff data provided
  website: "https://eng.kantiana.ru/", // Official English website
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://www.ruseducation.in/wp-content/uploads/2022/07/Immanuel-Kant-Baltic-Federal-University.jpg", // Representative image
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQsZWaW5Jbcelo9MniUuyrx4TTKaCBZk3IN7w&s", // Logo (illustrative)
 },
 {
  id: "4",
  universityDescription: `Kabardino Balkarian Medical University, established in 1932 in Nalchik, Russia, is a renowned institution known for its affordable and quality medical education. It provides a six-year MBBS course in English medium for international students.<br/><br/>

<strong>Highlights</strong><br/>
• Founded in 1932 with a long-standing reputation for excellence in medical education.<br/>
• 6-year MBBS program includes extensive practical exposure.<br/>
• Affordable tuition and hostel fees compared to many other countries.<br/>
• The 1st semester includes Registration, Visa Extension, Medical Check-up, Biometric-Fingerprint, Documentation Translation, SIM card, Airport pickup, and Administrative Charges.<br/>
• English medium of instruction throughout the course.<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• 1st Semester: $3550 (~₹2,84,000)<br/>
• 2nd–12th Semesters: 115,600 RUB each (~₹1,15,600/semester)<br/>
• Total for 6 years: $19,445 (~₹15,55,600)<br/><br/>

<strong>Other Expenses</strong><br/>
• Food: ₹4,000/month (self-cooking) or ~$100/month (mess)<br/>
• Exchange Rate Considered: 1 USD = ₹80, 1 RUB = ₹1.00<br/>
• Tuition fee may change and will be confirmed at the time of admission.<br/><br/>

<strong>Admission Details</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• Total Initial Charges: ₹120,000<br/><br/>

For more information, contact:<br/>
Admission Possibility<br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a>, <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Kabardino Balkarian Medical University",
  established: "1932",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by Russian Ministry of Health",
  address: "Nalchik, Kabardino-Balkarian Republic, Russia",
  state: "Kabardino-Balkarian Republic",
  city: "Nalchik",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: KabardinoBalkarianMedicalUniversityPDF, // replace with actual PDF variable or file name if needed
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "$19,445 (~₹15,55,600)",
   },
  ],
  cutoffdata: [],
  website: "https://www.kbmu.ru", // official Russian site, no English version available
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://www.yashoverseas.org/wp-content/uploads/2024/01/kabardino-scaled.jpg", // representative image
  image2: "https://dreammedicine.in/admin/ugalary/947.png", // university logo
 },
 {
  id: "5",
  universityDescription: `Kazan Federal University, established in 1804, is one of the oldest and most prestigious universities in Russia. Ranked 4th in the country, it offers high-quality education, especially in the field of medicine. The MBBS program is taught in English and spans six years.<br/><br/>

<strong>Highlights</strong><br/>
• Established in 1804 – over two centuries of academic excellence.<br/>
• Country Rank: 4<br/>
• 6-year MBBS program offered in English medium.<br/>
• Affordable fee structure with a modern curriculum and global recognition.<br/>
• Recognized for its world-class research, infrastructure, and practical training in medicine.<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Year:</strong> 700,000 RUB (~₹700,000)<br/>
• <strong>2nd–6th Year:</strong> 488,500 RUB/year (~₹488,500)<br/>
• <strong>Total (6 years):</strong> 3,142,500 RUB (~₹31,42,500)<br/>
(Fees include Tuition, Hostel, Medical Insurance, Visa Renewal)<br/><br/>

<strong>Other Expenses</strong><br/>
• Food: ~$100–120/month (approx. ₹85,000/year)<br/>
• Exchange Rate: 1 RUB = ₹1.00 (approximate)<br/>
• Tuition fee subject to change and will be confirmed at the time of admission.<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Initial Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
Admission Possibility<br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a>, <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Kazan Federal University",
  established: "1804",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by Russian Ministry of Health and WHO",
  address: "Kremlyovskaya St, 18, Kazan, Republic of Tatarstan, Russia, 420008",
  state: "Republic of Tatarstan",
  city: "Kazan",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: KazanFederalUniversityPDF, // replace with actual PDF variable or file name if needed
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "3,142,500 RUB (~₹31,42,500)",
   },
  ],
  cutoffdata: [],
  website: "https://kpfu.ru/eng",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://www.ruseducation.in/wp-content/uploads/2022/01/Kazan-Federal-University.webp", // representative image
  image2:
   "https://upload.wikimedia.org/wikipedia/commons/thumb/7/7d/Kazan_Federal_University_Logo.jpg/640px-Kazan_Federal_University_Logo.jpg", // university logo
 },
 {
  id: "6",
  universityDescription: `Kazan State Medical University, established in 1814, is one of the oldest and most respected government medical universities in Russia. It offers a 6-year MBBS program taught in English and is recognized globally for its academic excellence and advanced medical training facilities.<br/><br/>

<strong>Highlights</strong><br/>
• Founded: 1814<br/>
• Type: Government sector medical university<br/>
• Medium: English<br/>
• Duration: 6 years<br/>
• Eligibility: Minimum 62–65% in each subject (English, Biology, Chemistry)<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Year:</strong> 8000 USD (~₹6,40,000)<br/>
  (Includes Tuition Fee, Hostel, Medical Insurance, Visa Renewal, Police Registration, Ministry of Health Registration, etc.)<br/>
• <strong>2nd–6th Year:</strong> 6110 USD/year (~₹4,88,800/year)<br/>
• <strong>Total (6 years):</strong> 38,550 USD (~₹30,84,000)<br/><br/>

<strong>Other Expenses</strong><br/>
• Food: ~$100–120/month (approx. ₹1,00,000/year)<br/>
• Private hostel charges (if no seat available in government hostel): $1000 (one-time payment)<br/>
• Fees are subject to change with exchange rates and university policy.<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Initial Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a>, <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Kazan State Medical University",
  established: "1814",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by Russian Ministry of Health and WHO",
  address:
   "Kazan State Medical University, Butlerov St, 49, Kazan, Republic of Tatarstan, Russia, 420012",
  state: "Republic of Tatarstan",
  city: "Kazan",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: KazanStateMedicalUniversityPDF, // replace with actual PDF variable or file name if needed
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "38,550 USD (~₹30,84,000)",
   },
  ],
  cutoffdata: [],
  website: "https://kazangmu.ru/en",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://navchetana.education/assets/images/universities/Russia/Kazan-State.jpg",
  image2:
   "https://www.prologueabroad.com/wp-content/uploads/2022/02/ksmu-logo.jpg",
 },
 {
  id: "7",
  universityDescription: `Kemerovo State University, established in 1973, is a recognized public university in Russia offering a 6-year MBBS course with internship in English medium. The university is well-equipped with modern infrastructure, experienced faculty, and international-standard labs.<br/><br/>

<strong>Highlights</strong><br/>
• Founded: 1973<br/>
• Type: Government/Public University<br/>
• Medium: English<br/>
• Duration: 6 years (including internship)<br/><br/>

<strong>Eligibility Criteria</strong><br/>
• As per NMC guidelines<br/>
• 50% marks in PCB for general category; 40% for reserved<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Year:</strong> 6000 USD (~₹4,80,000)<br/>
  (Includes Tuition Fee, Hostel, One-Time Charges)<br/>
• <strong>2nd–6th Year:</strong> 245,300 RUB/year (~₹2,45,300/year)<br/>
  (Includes Tuition Fee, Accommodation, Medical Insurance, Visa Renewal)<br/>
• <strong>Total (2nd to 6th Year):</strong> 1,226,500 RUB (~15,400 USD / ₹12,26,500)<br/>
• <strong>Total for 6 Years:</strong> 21,400 USD (~₹17,06,500)<br/><br/>

<strong>Other Expenses</strong><br/>
• Food: ₹5000–6000/month (Self Cooking)<br/>
• Mess Charges: ~120 USD/month<br/>
• Fees may vary based on current USD/RUB exchange rates<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Initial Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a>`,

  collegename: "Kemerovo State University",
  established: "1973",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by Russian Ministry of Health and WHO",
  address: "Kemerovo State University, 6 Krasnaya St, Kemerovo, Russia, 650000",
  state: "Kemerovo Oblast",
  city: "Kemerovo",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: KemerovoStateUniversityPDF, // Replace with actual PDF variable or filename if needed
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years (with internship)",
    tuitionFee: "21,400 USD (~₹17,06,500)",
   },
  ],
  cutoffdata: [],
  website: "https://www.kemsu.ru/en",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://www.yashoverseas.org/wp-content/uploads/2024/02/Kemerovo-State-University-scaled.jpg",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcToLB4mVWfozQ1EyenPBIdrY8Vv3ePttl3PUQ&s",
 },
 {
  id: "8",
  universityDescription: `Kursk State Medical University (KSMU), established in 1935, is a prestigious government medical university located in Kursk, Russia. It is one of the oldest and most reputed medical universities in Russia and is known for being the first to offer a full medical program in English medium.<br/><br/>

<strong>Highlights</strong><br/>
• Established: 1935<br/>
• Location: Kursk, Russia<br/>
• Type: Government University<br/>
• Medium: English<br/>
• Duration: 6 years (including clinical internship)<br/><br/>

<strong>Eligibility Criteria</strong><br/>
• Minimum 50% in PCB (for General category), 40% (for Reserved categories)<br/>
• NEET qualification mandatory as per NMC guidelines<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Year:</strong> 8000 USD (~₹6,40,000)<br/>
  (Includes Tuition Fee, Hostel, Miscellaneous, Registration, Visa, Medical Insurance, etc.)<br/>
• <strong>2nd–6th Year:</strong> 6200 USD/year (~₹4,96,000/year)<br/>
  (Includes Tuition + Accommodation)<br/>
• <strong>Total (2nd–6th Year):</strong> 31,000 USD (~₹24,80,000)<br/>
• <strong>Grand Total for 6 Years:</strong> 39,000 USD (~₹31,20,000)<br/><br/>

<strong>Other Expenses</strong><br/>
• Medical Insurance & Visa Renewal: 6500–7000 RUB/year<br/>
• Food: 100–120 USD/month (~₹75,000/year)<br/>
• Rates subject to currency fluctuations (1 USD = ₹80)<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Admission Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a>`,

  collegename: "Kursk State Medical University",
  established: "1935",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address:
   "Kursk State Medical University, ul. K. Marksa, 3, Kursk, Kursk Oblast, Russia, 305000",
  state: "Kursk Oblast",
  city: "Kursk",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: KurskStateMedicalUniversityPDF, // Replace with actual PDF file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years (with internship)",
    tuitionFee: "39,000 USD (~₹31,20,000)",
   },
  ],
  cutoffdata: [],
  website: "https://kurskmed.com",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://lh6.googleusercontent.com/proxy/Qo7OfA49nORiDcMh4fZ_VkikVvWHJSIDHIETwSAXD1wP0twM2U9nn9LJ3ZEtoD-dK07pmb6H3Aab2O7R4xfqcUoo8wQbpOnUptX28tvwAjPpF6iax0dg6-RHBafOU_uOtQ",
  image2:
   "https://upload.wikimedia.org/wikipedia/en/f/f6/Kursk_State_Medical_University_logo.png",
 },
 {
  id: "9",
  universityDescription: `Northern State Medical University (NSMU), established in Arkhangelsk, Russia, is one of the top government medical institutions in Northern Russia. It offers a fully English-medium MBBS program that spans six years, including clinical internship, and is recognized by the NMC and WHO.<br/><br/>

<strong>Highlights</strong><br/>
• Established: N/A<br/>
• Location: Arkhangelsk, Russia<br/>
• Type: Government University<br/>
• Medium: English<br/>
• Duration: 6 years (including internship)<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Year:</strong> 7500 USD (~₹6,00,000)<br/>
  (Includes Tuition Fee, Hostel, and other miscellaneous charges like Hostel Security)<br/>
• <strong>2nd–6th Year:</strong> 6200 USD/year (~₹4,96,000/year)<br/>
• <strong>Total (2nd–6th Year):</strong> 31,000 USD (~₹24,80,000)<br/>
• <strong>Grand Total for 6 Years:</strong> 38,500 USD (~₹30,80,000)<br/><br/>

<strong>Other Expenses</strong><br/>
• Hostel Security (1st Year): 350 USD<br/>
• Medical Insurance & Visa Renewal (from 2nd Year): 150 USD/year<br/>
• Food: 1200 USD/year (~₹95,000/year)<br/>
• Currency Rate Considered: 1 USD = ₹80<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Admission Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Northern State Medical University",
  established: "N/A",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "Northern State Medical University, Arkhangelsk, Russia",
  state: "Arkhangelsk Oblast",
  city: "Arkhangelsk",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: NorthernStateMedicalUniversityPDF, // Replace with actual PDF file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years (with internship)",
    tuitionFee: "38,500 USD (~₹30,80,000)",
   },
  ],
  cutoffdata: [],
  website: "https://nsmu.ru/en",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://www.ruseducation.in/wp-content/uploads/2022/01/Northern-State-Medical-University-1.webp",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQm_IefNEbdJcKRGSAhqSwbD7k5UlCpFV9-cQ&s",
 },
 {
  id: "10",
  universityDescription: `Orel State University, established in 1931, is one of Russia's renowned government universities offering the MBBS course in English medium. The course spans 6 years including an internship. The university provides affordable tuition and accommodation options with necessary facilities for international students.<br/><br/>

<strong>Highlights</strong><br/>
• Established: 1931<br/>
• Location: Orel, Russia<br/>
• Type: Government University<br/>
• Medium: English<br/>
• Duration: 6 years (including internship)<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Semester:</strong> 3815 USD (~₹3,05,200)<br/>
• <strong>2nd–12th Semesters:</strong> 1685 USD/semester (~₹1,34,825)<br/>
• <strong>Total (2nd–12th Semesters):</strong> 18535 USD (~₹14,83,075)<br/>
• <strong>Total for 6 Years:</strong> 22,350 USD (~₹17,88,275)<br/><br/>

<strong>Other Expenses</strong><br/>
• Miscellaneous Charges in 1st Year: Includes registration, visa extension, medical, fingerprinting, airport pickup, documents translation, SIM card, etc.<br/>
• Food Charges (Mess): 100 USD/month (~₹8,000/month)<br/>
• Private Hostel (if government hostel not allotted): Extra 35,000 RUB (~₹35,000)<br/>
• Exchange Rate Used: 1 USD = ₹80<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Admission Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Orel State University",
  established: "1931",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "Orel State University, Orel, Russia",
  state: "Oryol Oblast",
  city: "Orel",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: OrelStateMedicalUniversityPDF, // Replace with actual PDF file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years (with internship)",
    tuitionFee: "22,350 USD (~₹17,88,275)",
   },
  ],
  cutoffdata: [],
  website: "https://www.oreluniver.ru/en",
  mail: "admissionpossibility@gmail.com",
  image1: "https://studymbbsinrussia.co.in/wp-content/uploads/2014/06/Orel.jpg",
  image2:
   "https://sportcdns.live/resized/224/224/team/d44cac3d46bfc786116162488f49520be41e91ad6fd9aabf72a8bb5875dbb028.png",
 },
 {
  id: "11",
  universityDescription: `Rostov State Medical University is one of the oldest and most prestigious medical universities in Southern Russia. The university offers a 6-year MBBS program with world-class facilities, experienced faculty, and quality medical education in English medium.<br/><br/>

<strong>Highlights</strong><br/>
• Established: Not specified<br/>
• Location: Rostov-on-Don, Russia<br/>
• Type: Government Medical University<br/>
• Medium: English<br/>
• Duration: 6 years<br/>
• Entrance Exam: Chemistry & Biology (Class 12th with 60% minimum in PCB required)<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
• <strong>1st Year:</strong> 7500 USD (~₹6,00,000)<br/>
• Includes tuition, hostel, registration, medical insurance, visa extension, SIM card, fingerprinting, admin charges, etc.<br/>
• <strong>2nd to 6th Year:</strong> 4700 USD/year (~₹3,76,000/year)<br/>
• Includes tuition, hostel, registration, medical insurance, visa extension<br/>
• <strong>Total (2nd to 6th Year):</strong> 23,500 USD (~₹18,80,000)<br/>
• <strong>Grand Total (6 Years):</strong> 31,000 USD (~₹24,80,000)<br/><br/>

<strong>Other Expenses</strong><br/>
• Indian Mess (Lunch + Dinner): 1220 USD (Mandatory in 1st Year)<br/>
• Exchange Rate Used: 1 USD = ₹80<br/><br/>

<strong>Admission Charges</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing: ₹100,000<br/>
• <strong>Total Admission Charges:</strong> ₹120,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Rostov State Medical University",
  established: "",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "Rostov State Medical University, Rostov-on-Don, Russia",
  state: "Rostov Oblast",
  city: "Rostov-on-Don",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: RostovStateMedicalUniversityPDF, // Replace with actual file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "31,000 USD (~₹24,80,000)",
   },
  ],
  cutoffdata: [],
  website: "https://www.rsmu.ru/en/",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://rrecrostov.ru/static/media/BgSlider1.08abefe7489e8089c6aa.jpg",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcQk9m1lfW_cd0VaHH64wUqEDxKbBsD-scTLHQ&s",
 },
 {
  id: "12",
  universityDescription: `South Ural State Medical University (SUSMU), established in 1943, is a prestigious government medical institution in Chelyabinsk, Russia. The university offers excellent academic and clinical education with a strong emphasis on research and scientific innovation. It is home to a Central Research Laboratory, an Experimental Biological Clinic, and an Immunology Research Institute.<br/><br/>

<strong>Highlights</strong><br/>
• Established: 1943<br/>
• Location: Chelyabinsk, Russia<br/>
• Type: Government Medical University<br/>
• Medium: English<br/>
• Duration: 6 Years<br/>
• Research Facilities: Central Research Lab, Immunology Institute, Experimental Clinic<br/>
• Hostels: 5 hostels with 2,246 beds (2-3 students/room, kitchen & laundry on each floor)<br/><br/>

<strong>Fee Structure (2023–24)</strong><br/>
<strong>1st Year:</strong><br/>
• Tuition + Hostel + Insurance + Medical Test + Visa Renewal + Miscellaneous<br/>
• 430,000 Rubles (~₹4,30,000)<br/><br/>

<strong>2nd to 6th Year:</strong><br/>
• Tuition + Hostel = 276,400 Rubles/year (~₹2,76,400/year)<br/>
• Total for 5 Years: 13,82,000 Rubles (~₹13,82,000)<br/><br/>

<strong>Total (6 Years):</strong> 18,12,000 Rubles (~₹18,12,000)<br/><br/>

<strong>Optional One-Time Package:</strong><br/>
• 14,00,000 Rubles (Tuition + Hostel for full course)<br/>
• Savings of approximately 4,20,000 Rubles<br/><br/>

<strong>Other Expenses:</strong><br/>
• Biometric Registration & Drug Screening (1st year): ~12,500 Rubles<br/>
• Medical Insurance + Check-up + Visa Renewal (from 2nd year): ~10,000–12,000 Rubles/year<br/>
• Food: ~100 USD/month (Self-cooking option available)<br/><br/>

<strong>Exchange Rate Used:</strong> 1 RUB = ₹1<br/><br/>

<strong>Admission Charges:</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing Fee: ₹1,00,000<br/>
• <strong>Total Admission Charges:</strong> ₹1,20,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "South Ural State Medical University",
  established: "1943",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "South Ural State Medical University, Chelyabinsk, Russia",
  state: "Chelyabinsk Oblast",
  city: "Chelyabinsk",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: SouthUralStateMedicalUniversityPDF, // Replace with actual file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "18,12,000 Rubles (~₹18,12,000)",
   },
  ],
  cutoffdata: [],
  website: "https://www.susmu.ru/",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://blog.rmgoe.org/wp-content/uploads/2023/05/South-Ural-State-Medical-University-Russia-1.jpg",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTFFaRjhfqNEqyqtNwpIdS7V0qnpP-fVmx3Ng&s",
 },
 {
  id: "13",
  universityDescription: `Tver State Medical University (TSMU), established in 1920, is one of the oldest and most reputed medical institutions in Russia. Located in Tver, it is recognized for its high academic standards, strong research infrastructure, and international student support system. The MBBS program at TSMU is a 6-year course including an internship.<br/><br/>

<strong>Highlights:</strong><br/>
• Established: 1920<br/>
• Location: Tver, Russia<br/>
• Type: Government Medical University<br/>
• Course Duration: 6 years (with internship)<br/>
• Medium of Instruction: English<br/><br/>

<strong>Fee Structure for MBBS (2023–24):</strong><br/>
<strong>1st Year:</strong><br/>
• 1st Semester (Tuition + Hostel + One-time Charges): 4135 USD (~₹3,30,800)<br/>
<strong>2nd to 12th Semester (each):</strong><br/>
• Tuition + Hostel Fee: 149,264 Rubles (~1865 USD or ₹1,49,264)<br/>
• 11 semesters × ₹1,49,264 = ₹16,42,904<br/><br/>

<strong>Total (6 Years):</strong><br/>
• USD: 24,650<br/>
• INR: ₹19,72,704 (as per 1 USD = ₹80)<br/><br/>

<strong>Other Inclusions in 1st Year:</strong><br/>
• Registration, Visa Extension, Medical Checkup, Biometric Fingerprint, Airport Pick-up, Sim Card, Translation of Documents, etc.<br/><br/>

<strong>Food:</strong><br/>
• Approximately 1000 USD/Year (~₹80,000/year)<br/><br/>

<strong>Exchange Rate Used:</strong> 1 USD = ₹80<br/><br/>

<strong>Admission Charges:</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing Fee: ₹1,00,000<br/>
• <strong>Total Admission Charges:</strong> ₹1,20,000<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Tver State Medical University",
  established: "1920",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "Tver State Medical University, Tver, Russia",
  state: "Tver Oblast",
  city: "Tver",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: TverStateMedicalUniversityPDF, // Replace with actual file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "24,650 USD (~₹19,72,704)",
   },
  ],
  cutoffdata: [],
  website: "https://tvgmu.ru/",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://www.yashoverseas.org/wp-content/uploads/2024/02/Tver-State-Medical-University-scaled.jpg",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSY421GlP5L4BYWIasGnPxujEReH162SDYZXg&s",
 },
 {
  id: "14",
  universityDescription: `Yaroslavl State Medical University (YSMU), established in 1944, is one of the most prestigious medical universities in Russia. Located in Yaroslavl, a historic city with cultural and educational significance, the university is well-known for its modern teaching methods, experienced faculty, and international student programs.<br/><br/>

<strong>Highlights:</strong><br/>
• Established: 1944<br/>
• Location: Yaroslavl, Russia<br/>
• Type: Government Medical University<br/>
• Course Duration: 6 years (including internship)<br/>
• Medium of Instruction: English<br/><br/>

<strong>Fee Structure for MBBS (2023–24):</strong><br/>
<strong>1st Year:</strong><br/>
• Tuition + Hostel + Miscellaneous Charges: 415,000 Rubles (~₹4,15,000)<br/><br/>

<strong>2nd to 6th Year (per year):</strong><br/>
• Tuition Fee: 250,000 Rubles<br/>
• Hostel Fee: 11,000 Rubles<br/>
• Total per year: 261,000 Rubles (~₹2,61,000)<br/>
• 5 Years Total: 1,305,000 Rubles (~₹13,05,000)<br/><br/>

<strong>Grand Total (6 Years):</strong><br/>
• Rubles: 1,720,000<br/>
• INR: ₹17,20,000 (Calculated @ 1 Ruble = ₹1.00)<br/><br/>

<strong>Food:</strong><br/>
• Mess Charges: Approximately 1200 USD/year (~₹96,000/year)<br/><br/>

<strong>Admission Charges:</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing Fee: ₹1,00,000<br/>
• <strong>Total Admission Charges:</strong> ₹1,20,000<br/><br/>

<strong>Note:</strong> Tuition fees may change. Final fees will be informed at the time of admission.<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Yaroslavl State Medical University",
  established: "1944",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "Yaroslavl State Medical University, Yaroslavl, Russia",
  state: "Yaroslavl Oblast",
  city: "Yaroslavl",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: YaroslavlStateMedicalUniversityPDF, // Replace with actual file if available
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "1,720,000 Rubles (~₹17,20,000)",
   },
  ],
  cutoffdata: [],
  website: "https://www.ysmu.ru/",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://ysmu.ru/upload/medialibrary/528/cp1czdetysqeraua0swf908rnywggqgb/ysmu.jpg",
  image2:
   "https://media.globaladmissions.com/media/school_logos/yaroslavl-state-medical-university.png?width=256&quality=100",
 },
 {
  id: "15",
  universityDescription: `Yaroslav-the-Wise Novgorod State University, founded in 1993, is one of Russia’s youngest yet highly reputed public universities offering MBBS to international students. The university is located in Veliky Novgorod, a historically significant city known for its educational and cultural prominence.<br/><br/>

<strong>Highlights:</strong><br/>
• Established: 1993<br/>
• Location: Veliky Novgorod, Russia<br/>
• Type: Government Medical University<br/>
• Course Duration: 6 years<br/>
• Medium of Instruction: English<br/><br/>

<strong>Fee Structure for MBBS (2023–24):</strong><br/>
<strong>1st Year:</strong><br/>
• Tuition + Hostel + Miscellaneous Charges: 6,500 USD (~₹5,20,000)<br/><br/>

<strong>2nd to 6th Year (per year):</strong><br/>
• Tuition Fee: 4,100 USD<br/>
• Visa Renewal: 150 USD<br/>
• Medical Insurance: 150 USD<br/>
• Total per year: 4,400 USD (~₹3,52,000)<br/>
• 5 Years Total: 22,000 USD (~₹17,60,000)<br/><br/>

<strong>Grand Total (6 Years):</strong><br/>
• USD: 28,500<br/>
• INR: ₹22,80,000 (Calculated @ 1 USD = ₹80/-)<br/><br/>

<strong>Food:</strong><br/>
• Self Cooking: ₹4,000–₹5,000/month<br/>
• Mess Charges: 100 USD/month (~₹8,000/month)<br/><br/>

<strong>Admission Charges:</strong><br/>
• Admission Fee (Non-refundable): ₹20,000<br/>
• Visa, Documentation & Processing Fee: ₹1,00,000<br/>
• <strong>Total Admission Charges:</strong> ₹1,20,000<br/><br/>

<strong>Note:</strong> Tuition fee may change. Final fees will be informed at the time of admission.<br/><br/>

For more information, contact:<br/>
<strong>Admission Possibility</strong><br/>
812, 8th Floor, Tower 2, Assotech Business Cresterra, Sec-135, Noida-201301<br/>
Contact: +91-9650865123<br/>
Email: admissionpossibility@gmail.com<br/>
Website: <a href="http://www.admissionpossibility.com" target="_blank">www.admissionpossibility.com</a> | <a href="http://www.neetug.live" target="_blank">www.neetug.live</a>`,

  collegename: "Yaroslav-the-Wise Novgorod State University",
  established: "1993",
  collegetype: "Government",
  location: "Russia",
  approval: "Recognized by NMC, WHO, and Russian Ministry of Health",
  address: "Veliky Novgorod, Russia",
  state: "Novgorod Oblast",
  city: "Veliky Novgorod",
  affiliatedby: "Russian Ministry of Health and Education",
  collegecategory: "Medical",
  pdf: YaroslavTheWiseNovgorodUniversityPDF, // Replace with actual file reference
  courses: [
   {
    course: "MBBS",
    branch: "Bachelor of Medicine & Bachelor of Surgery",
    totalSeat: null,
    courseDuration: "6 years",
    tuitionFee: "28,500 USD (~₹22,80,000)",
   },
  ],
  cutoffdata: [],
  website: "https://www.novsu.ru/",
  mail: "admissionpossibility@gmail.com",
  image1:
   "https://winteruniversity.ru/upload/iblock/a6d/xtc9r5sosulatb03ne4ctlawgq0umwbz/IMG_7883.JPG",
  image2:
   "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcTQBMJ-Y1OeD9Z03BxXawkWOsb2J7Ijctk2ZQ&s",
 },
];
